import React, { useState } from 'react';
import Modal from '../../../../components/ui/Modal';
import { Button } from '../../../../components/ui/Button';
import { AppIcon } from '../../../../components/icons/AppIcon';

interface DeleteConnectionModalProps {
    isOpen: boolean;
    connectionName: string;
    onConfirm: () => Promise<void>;
    onCancel: () => void;
}

export const DeleteConnectionModal: React.FC<DeleteConnectionModalProps> = ({
    isOpen,
    connectionName,
    onConfirm,
    onCancel
}) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleConfirm = async () => {
        setIsDeleting(true);
        try {
            await onConfirm();
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel}
            size="md"
            preventBackdropClose={isDeleting}
        >
            {/* Header customizado vermelho */}
            <div className="bg-red-600 px-5 py-4 flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <AppIcon name="alert-triangle" className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-lg font-bold text-white">
                    ATENÇÃO - Perda permanente de dados!
                </h3>
            </div>

            <Modal.Body>
                <p className="text-default">
                    Você está prestes a excluir a conexão <strong>"{connectionName}"</strong>.
                </p>

                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <p className="text-red-800 text-sm">
                        Se esta conexão é utilizada para o chat, ao excluir, <strong>TODAS as mensagens</strong> associadas a essa conexão serão excluídas permanentemente e <strong>NÃO poderão ser revertidas</strong>.
                    </p>
                </div>

                <p className="text-muted text-sm">
                    Esta ação é irreversível. Deseja continuar?
                </p>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="ghost"
                    onClick={onCancel}
                    disabled={isDeleting}
                >
                    Cancelar
                </Button>
                <Button
                    variant="danger"
                    onClick={handleConfirm}
                    disabled={isDeleting}
                >
                    {isDeleting ? (
                        <span className="flex items-center gap-2">
                            <AppIcon name="loader" className="w-4 h-4 animate-spin" />
                            Excluindo...
                        </span>
                    ) : (
                        'Excluir permanentemente'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConnectionModal;
